import interval from "./interval.js";
import {durationDay, durationMinute} from "./duration.js";

var day = interval(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
}, function(date) {
  return date.getDate() - 1;
});

export default day;
export var days = day.range;



//////////////////
// WEBPACK FOOTER
// ./~/d3-time/src/day.js
// module id = ./node_modules/d3-time/src/day.js
// module chunks = 54